import { dateToFloatingString } from '../utilities/dateTime';

/**
 * Position model. Encapsulating specific fields required by /position APIs.
 */
export default class Position {
    constructor(values) {
        const {
            // step 1 fields
            id,
            client_id,
            title,
            description,
            department,
            start_date,
            end_date,
            comp_code,
            rate,
            // rate_currency,
            hours_per_week,
            contract_value,
            po_when,
            po_number,
            po_value,
            po_date,
            tracking_number,
            classify_client_answers,
            classify_client_pref,
            classify_client_result,
            pay_type,
            work_location_type,
            work_location_onsite_id,
            work_timezone,
            country,
            // step 2 fields
            hm_id,
            // unknown fields
            deliverables,
            backup_approval_id,
            bg_check
        } = values;

        this.id = id;
        this.client_id = client_id;
        this.title = title;
        this.description = description;
        this.department = department;
        this.start_date = dateToFloatingString(start_date, 'YYYY-MM-DD');
        this.end_date = end_date ? dateToFloatingString(end_date, 'YYYY-MM-DD') : undefined;
        this.comp_code = comp_code;
        this.rate = rate;
        // this.rate_currency = rate_currency;
        this.hours_per_week = hours_per_week;
        this.contract_value = contract_value;
        this.po_when = po_when;
        this.po_number = po_number;
        this.po_value = po_value;
        this.po_date = po_date;
        this.tracking_number = tracking_number;
        this.classify_client_answers = classify_client_answers;
        this.classify_client_pref = classify_client_pref;
        this.classify_client_result = classify_client_result;
        this.pay_type = pay_type;
        this.deliverables = deliverables;
        this.work_location_type = work_location_type;
        this.work_location_onsite_id = work_location_type !== 'offsite' ? work_location_onsite_id : undefined;
        this.work_timezone = work_timezone;
        this.country = country;
        this.hm_id = hm_id;
        this.backup_approval_id = backup_approval_id;
        this.deliverables = deliverables;
        this.bg_check = bg_check;
    }
}



// WEBPACK FOOTER //
// ./src/models/position.jsx